export default {"src":"/_next/static/media/desktopDevice.1dd4fc89.svg","height":169,"width":168,"blurWidth":0,"blurHeight":0};